(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero_banner_slide-bkp"] && !Shopify.designMode) return;
  try {
    


$(document).ready(function () {

  

// $(window).on('scroll', function () {
//     let scrollTop = $(this).scrollTop();
//     let windowHeight = $(window).height();

//     $('.hero-banner-info').each(function () {
//         let $target = $(this);
//         let targetOffsetTop = $target.offset().top;
//         let targetHeight = $target.outerHeight();
//         let targetBottom = targetOffsetTop + targetHeight + 100;

//         // Trigger when bottom is within 200px of viewport bottom
//         if (scrollTop + windowHeight >= targetBottom ) {
//             if (!$target.hasClass('herobanner')) {
//                 $target.addClass('herobanner');
//                 // console.log('Added herobanner to one section');
//             }
//         } else {
//             if ($target.hasClass('herobanner')) {
//                 $target.removeClass('herobanner');
//                 // console.log('Removed herobanner from one section');
//             }
//         }
//     });
// });



  
  // function initDesktopAnimations() {
  //   gsap.registerPlugin(ScrollTrigger);
  //   ScrollTrigger.defaults({
  //     markers: false,
  //   });

  //   // Animate text opacity out on scroll
  //   gsap.utils.toArray('.banner_component').forEach(element => {
  //     const text = element.querySelector('.hero-banner-text');
  //     if (text) {
  //       gsap.to(
  //         text,
  //         {
  //           opacity: 0,
  //           ease: "power4.out",
  //           scrollTrigger: {
  //             trigger: element,
  //             start: "90% top",
  //             end: "100% top",
  //             scrub: 1,
  //           },
  //         }
  //       );
  //     }
  //   });
  // }

  // Initialize animations for large screens only
  if (window.innerWidth > 1100) {
    initDesktopAnimations();
  }

});


  
  
$(document).ready(function () {
  // Function to initialize desktop animations
  function initDesktopAnimations() {
    gsap.registerPlugin(ScrollTrigger);

    // Set default ScrollTrigger configurations
    ScrollTrigger.defaults({
      markers: false, // Turn markers off for production
      scrub: 1,       // Make animation smooth with scrub effect
    });

    // Targeting all sections with the class 'hero-banner-info'
    $('.hero-banner-info').each(function (index, element) {
      const text = $(element).find('.hero-banner-text');
      const contentImage = $(element).find('.hero-banner-image img');

      // Animate text
      if (text.length) {
        gsap.to(text, {
          y: -50,             // Move upward 50px
          opacity: 0,         // Fade out
          ease: "power2.inOut",
          scrollTrigger: {
            trigger: element,
            start: "80% center",   // Start earlier for smoother transition
            end: "100% top",
            scrub: true,
          },
        });
      }

      // Animate image
      if (contentImage.length) {
        gsap.to(contentImage, {
          y: 0,             // Move upward 30px
          opacity: 0.3,       // Slight fade out
          scale: 1,        // Slight zoom-out effect for depth
          ease: "power2.inOut",
          scrollTrigger: {
            trigger: element,
            start: "80% center",
            end: "100% top",
            scrub: true,
          },
        });
      }
    });

  }

  // Only initialize desktop animations if the window width is greater than 1100px
  
    initDesktopAnimations();
 
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero_banner_slide"] && !Shopify.designMode) return;
  try {
    


$(document).ready(function () {

  

$(window).on('scroll', function () {
    let scrollTop = $(this).scrollTop();
    let windowHeight = $(window).height();

    $('.hero-banner-info').each(function () {
        let $target = $(this);
        let targetOffsetTop = $target.offset().top;
        let targetHeight = $target.outerHeight();
        let targetBottom = targetOffsetTop + targetHeight + 100;

        // Trigger when bottom is within 200px of viewport bottom
        if (scrollTop + windowHeight >= targetBottom ) {
            if (!$target.hasClass('herobanner')) {
                $target.addClass('herobanner');
                // console.log('Added herobanner to one section');
            }
        } else {
            if ($target.hasClass('herobanner')) {
                $target.removeClass('herobanner');
                // console.log('Removed herobanner from one section');
            }
        }
    });
});



  
  function initDesktopAnimations() {
    gsap.registerPlugin(ScrollTrigger);
    ScrollTrigger.defaults({
      markers: false,
    });

    // Animate text opacity out on scroll
    gsap.utils.toArray('.banner_component').forEach(element => {
      const text = element.querySelector('.hero-banner-text');
      if (text) {
        gsap.to(
          text,
          {
            opacity: 0,
            ease: "power4.out",
            scrollTrigger: {
              trigger: element,
              start: "90% top",
              end: "100% top",
              scrub: 1,
            },
          }
        );
      }
    });
  }

  // Initialize animations for large screens only
  if (window.innerWidth > 1100) {
    initDesktopAnimations();
  }

});


  
  
// $(document).ready(function () {
//   function initDesktopAnimations() {
//     gsap.registerPlugin(ScrollTrigger);
//     ScrollTrigger.defaults({
//       markers: false,
//     });
//     $('.hero-banner-info').each(function(index, element) {
//       const content = $(element).find('.hero-banner-content');
//       const text = $(element).find('.hero-banner-text');
//       gsap.to(text, {
//         opacity: 0,
//         ease: "power2.inOut",
//         scrollTrigger: {
//           trigger: element,
//           start: "90% top",
//           end: "100% top",
//           scrub: 1,
//         },
//       });
//     });
//   }
//   if (window.innerWidth > 1100) {
//     initDesktopAnimations();
//   }
// });
// gsap.registerPlugin(ScrollTrigger);

// $(document).ready(function () {
//   function initDesktopAnimations() {
//     gsap.registerPlugin(ScrollTrigger);

//     ScrollTrigger.defaults({
//       markers: true, // Enable for debugging
//     });

//     // Target all sections with the class 'hero-banner-info'
//     $('.hero-banner-content').each(function (index, element) {
//       const text = $(element).find('.hero-banner-text');

//       if (text.length) {
//         gsap.to(text, {
//           opacity: 0,
//           scrollTrigger: {
//             trigger: element,
//             start: "90% top",
//             end: "100% top",
//             scrub: 1,
//           },
//         });
//       }
//     });
//   }

//   if (window.innerWidth > 1100) {
//     initDesktopAnimations();
//   }
// });

// gsap.registerPlugin(ScrollTrigger);



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner"] && !Shopify.designMode) return;
  try {
    

  function bannerHeight(){
     const windowHeight = window.innerHeight;
      const belowSection = document.querySelector(".home-collection-section");
      const banner = document.querySelector(".main-banner-image"); 
      let sec = belowSection.offsetHeight - 20;
      let heightBanner = windowHeight - sec;
      banner.style.height = heightBanner + "px";
    // console.log('Load');
  }
    window.addEventListener("load", bannerHeight);
  window.addEventListener("resize", bannerHeight);
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["videowise-banner"] && !Shopify.designMode) return;
  try {
    

  function bannerHeight(){
     const windowHeight = window.innerHeight;
      const belowSection = document.querySelector(".home-collection-section");
      const banner = document.querySelector(".main-banner-image"); 
      let sec = belowSection.offsetHeight - 20;
      let heightBanner = windowHeight - sec;
      banner.style.height = heightBanner + "px";
    // console.log('Load');
  }
    window.addEventListener("load", bannerHeight);
  window.addEventListener("resize", bannerHeight);
  

  } catch(e) { console.error(e); }
})();
})();
